import './style/index.js';

import _Upload from './upload';

import type { TdUploadProps as UploadProps } from './type';

export const Upload = _Upload;

export type { UploadProps };
export * from './type';

export default Upload;
